import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepTitles: string[];
}

export default function ProgressBar({ currentStep, totalSteps, stepTitles }: ProgressBarProps) {
  return (
    <div className="mb-8">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
        {currentStep}/{totalSteps} {stepTitles[currentStep - 1]}
      </h2>

      <div className="relative h-3">
        <div className="absolute inset-0 bg-gray-200 rounded-full" />
        
        <div
          className="absolute inset-0 rounded-full transition-all duration-300"
          style={{
            width: `${(currentStep / totalSteps) * 100}%`,
            background: 'linear-gradient(to right, #2A4365, #4A5568, #C4A052)'
          }}
        />

        <div className="absolute inset-0 flex justify-between items-center px-1">
          {Array.from({ length: totalSteps }, (_, i) => (
            <div
              key={i}
              className={`w-5 h-5 rounded-full border-2 transition-all duration-300`}
              style={{
                background: i + 1 <= currentStep 
                  ? 'linear-gradient(to right, #2A4365, #4A5568, #C4A052)'
                  : '#E5E7EB',
                borderColor: i + 1 <= currentStep ? '#2A4365' : '#9CA3AF'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}